(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-b2m-select-card]').forEach((card) => {
      if (card.dataset.selectionReady) return;
      const data = JSON.parse(card.querySelector('[data-b2m-variant-data]').textContent);
      const form = card.querySelector('[data-b2m-picker-form]');
      const selects = [...card.querySelectorAll('[data-b2m-option-index]')];
      const input = card.querySelector('[data-b2m-variant-id]');
      const button = card.querySelector('[data-b2m-add]');
      const stock = card.querySelector('[data-b2m-stock]');
      const feedback = card.querySelector('[data-b2m-feedback]');
      const basket = card.querySelector('[data-b2m-basket]');
      const image = card.querySelector('[data-b2m-card-image]');
      const originalImage = image?.getAttribute('src');
      const originalPrice = card.querySelector('[data-b2m-original-price]');
      const price = card.querySelector('[data-b2m-current-price]');
      const priceBox = card.querySelector('[data-b2m-price]');
      const initialPrice = price.textContent;
      const initialOriginal = originalPrice?.textContent;
      const initialPence = [priceBox.dataset.b2mOriginalPence, priceBox.dataset.b2mPreviewPence];
      const colourIndex = data.optionNames.findIndex((name) => /colou?r/i.test(name));
      const imageFor = (variant) => variant?.image || (colourIndex >= 0 && variant ? data.variants.find((v) => v.image && v.options[colourIndex] === variant.options[colourIndex])?.image : null) || (data.variants.length === 1 ? originalImage : null);
      let selected = null;
      let busy = false;
      let uncertain = false;
      const update = () => {
        const values = selects.map((select) => select.value);
        selected = selects.length ? data.variants.find((v) => values.every((value, index) => value && v.options[index] === value)) : data.variants.find((v) => String(v.id) === String(data.initialVariantId));
        selects.forEach((select, index) => {
          [...select.options].forEach((option) => {
            if (!option.value) return;
            const matches = data.variants.filter((v) => v.options[index] === option.value && values.every((value, other) => other === index || !value || v.options[other] === value));
            const state = matches.length ? (matches.some((v) => v.available) ? '' : data.labels.soldOut) : data.labels.unavailable;
            option.textContent = option.dataset.label + (state ? ' - ' + state : '');
          });
        });
        input.value = selected ? String(selected.id) : '';
        input.disabled = !selected?.available || busy || uncertain;
        button.disabled = !selected?.available || busy || uncertain;
        button.textContent = busy ? data.labels.adding : selected && !selected.available ? data.labels.soldOut : data.labels.add;
        stock.textContent = selected ? (selected.available ? data.labels.stock : data.labels.soldOut) : values.every(Boolean) ? data.labels.unavailable : data.labels.choose;
        const url = selected ? data.productUrl + '?variant=' + selected.id : data.productUrl;
        card.querySelectorAll('[data-b2m-pdp-link]').forEach((link) => { link.href = url; });
        if (selected) {
          price.textContent = data.offer ? selected.previewText : selected.priceText;
          if (originalPrice) originalPrice.textContent = selected.priceText;
          if (data.offer) {
            priceBox.dataset.b2mOriginalPence = String(selected.price);
            priceBox.dataset.b2mPreviewPence = String(selected.preview);
          }
        } else {
          price.textContent = initialPrice;
          if (originalPrice) originalPrice.textContent = initialOriginal;
          if (data.offer) { priceBox.dataset.b2mOriginalPence = initialPence[0]; priceBox.dataset.b2mPreviewPence = initialPence[1]; }
        }
        const matchesOptions = (v) => values.every((value, index) => !value || v.options[index] === value);
        const previewVariant = selected || data.variants.find((v) => v.available && matchesOptions(v)) || data.variants.find(matchesOptions) || data.variants.find((v) => v.id === data.leadVariantId);
        const matchingImage = imageFor(previewVariant);
        const missingImage = !matchingImage;
        if (image) {
          image.hidden = missingImage;
          if (matchingImage) image.src = matchingImage;
          else image.removeAttribute('src');
          image.alt = data.title + (previewVariant && matchingImage ? ' - ' + previewVariant.options.filter((value) => value !== 'Default Title').join(' / ') : '');
        }
        card.querySelector('[data-b2m-missing-image]').hidden = !missingImage;
        card.querySelector('[data-b2m-image-note]').hidden = !missingImage;
        if (selected?.available && missingImage) { input.disabled = true; button.disabled = true; stock.textContent = data.labels.photoRequired; }
      };
      selects.forEach((select) => select.addEventListener('change', () => { feedback.hidden = true; update(); }));
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!selected?.available || button.disabled || busy || uncertain) return;
        const variantId = selected.id;
        busy = true;
        selects.forEach((select) => { select.disabled = true; });
        feedback.hidden = true;
        update();
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
            body: JSON.stringify({items: [{id: variantId, quantity: 1}], sections: 'cart-ajax', sections_url: location.pathname}),
            signal: AbortSignal.timeout(18000)
          });
          const payload = JSON.parse(await response.text());
          if (!response.ok) {
            feedback.textContent = typeof payload.description === 'string' ? payload.description : data.labels.error;
          } else if (!payload.items?.some((item) => String(item.variant_id || item.id) === String(variantId))) {
            throw new Error('Unconfirmed variant');
          } else {
            feedback.textContent = data.labels.added;
            if (payload.sections?.['cart-ajax']) button.dispatchEvent(new CustomEvent('ajaxProduct:added', {bubbles: true, detail: {product: payload, addToCartBtn: button}}));
          }
        } catch {
          uncertain = true;
          feedback.textContent = data.labels.uncertain;
        } finally {
          feedback.hidden = false;
          basket.hidden = false;
          busy = false;
          selects.forEach((select) => { select.disabled = false; });
          update();
        }
      });
      card.dataset.selectionReady = 'true';
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
